import React, { useEffect, useState, lazy } from 'react';
import { cn } from '@/lib/utils';
export const CTAButton = ({
  children,
  href = '#precio',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq && (href.includes('checkout') || href.includes('/cart/'))) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Vitalidad 360 Master Kit',
        content_category: 'Health',
        currency: 'ARS',
        value: 22990
      });
    }
  };
  return <a href={href} onClick={handleClick} className={cn(`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-cyan text-familia-bg hover:bg-familia-coral/90' : 'border-2 border-familia-cyan text-familia-cyan hover:bg-familia-cyan/10'} ${className}`, 'text-[18px] bg-[#10B929]')} data-id="element-193">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 54,
    s: 1
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-cyan w-full ${className}`} data-id="element-194">
      <div className="flex flex-col items-center" data-id="element-195">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-196">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-197">
          horas
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-198">:</div>
      <div className="flex flex-col items-center" data-id="element-199">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-200">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-201">
          minutos
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-202">:</div>
      <div className="flex flex-col items-center" data-id="element-203">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-204">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-205">
          segundos
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['5 módulos centrales', 'Módulo VIP con +150 ejercicios', '3 bonos incluidos', 'Actividades cognitivas y físicas por nivel', 'Bitácoras y registros de salud', 'Material imprimible', 'Acceso inmediato por email', 'Pago único y acceso de por vida'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(242,181,68,0.5)] sm:shadow-[0_0_50px_-12px_rgba(242,181,68,0.4)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-206">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-207">
        ⭐ SISTEMA COMPLETO 2026
      </div>
      <div className="text-center mt-4 mb-8" data-id="element-208">
        <h3 className="text-2xl font-display font-bold mb-1" data-id="element-209">
          Vitalidad 360™
        </h3>
        <p className="text-familia-gray text-sm uppercase tracking-widest" data-id="element-210">
          Master Kit Adultos Mayores
        </p>
      </div>
      <div className="flex items-center gap-4 mb-8 bg-familia-card/60 p-4 rounded-xl border border-white/5" data-id="element-211">
        <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitalidad 360 Master Kit" width="96" height="96" loading="lazy" className="w-24 h-24 object-contain" data-id="element-212" />
        <div className="flex flex-col items-start" data-id="element-213">
          <span className="text-familia-gray text-xs mb-1" data-id="element-214">
            Precio regular:
          </span>
          <span className="text-familia-red line-through text-lg mb-1" data-id="element-215">
            $95.000 ARS
          </span>
          <span className="text-familia-gray text-xs mb-1 mt-1" data-id="element-216">
            Precio de lanzamiento:
          </span>
          <div className="flex items-center gap-3" data-id="element-217">
            <span className="text-familia-cyan text-4xl font-bold" data-id="element-218">
              $22.990 ARS
            </span>
          </div>
          <span className="text-familia-gray text-[10px] mt-2" data-id="element-219">
            Pago único · Sin suscripciones · Acceso de por vida
          </span>
        </div>
      </div>

      <CTAButton href="https://vitalidad-360-adultos-mayores.impultienda.ar/checkout" className="w-full text-lg py-5 mb-4" data-id="element-220">
        SÍ, QUIERO EL KIT COMPLETO AHORA
      </CTAButton>
      <div className="mb-6 text-center" data-id="element-221">
        <div className="flex justify-center mb-4" data-id="element-222">
          <img src="https://cdn.magicpatterns.com/uploads/6R6tsYDvikk36g2pqfVG3S/garantia-7-dias-250.webp" alt="Garantía 30 días de reembolso" className="w-24 h-24 object-contain" style={{
          filter: 'hue-rotate(15deg)'
        }} data-id="element-223" />
        </div>
        <p className="text-xs text-familia-gray" data-id="element-224">
          Pago seguro · Acceso inmediato por email · Garantía 30 días
        </p>
      </div>
      <div className="text-center text-[10px] sm:text-xs text-familia-gray mb-8" data-id="element-225">
        🔒 Pagá con Mercado Pago · Tarjeta de crédito · Tarjeta de débito ·
        Dinero en cuenta
      </div>
      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-226">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-227">
            <span className="text-familia-green text-lg" data-id="element-228">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-229">{item}</span>
          </div>)}
      </div>
      <p className="text-center text-familia-gray text-xs mt-8" data-id="element-230">
        Pago único · Sin suscripciones mensuales · Acceso de por vida
      </p>
    </div>;
};